import { WebParameterContext,WebResponesContext} from '../../model/common';
declare var app;
export class ServicesSignIn{
constructor(){
    
}
public HandleWebParameterContextBeforeDBRequest(webcontext:WebParameterContext):WebParameterContext{
    if(webcontext.OpType =="down"){
        const mendian = localStorage.getItem("mendian");
        if(mendian){
            webcontext.OpType="add";
            webcontext.RequestBody = JSON.parse(webcontext.RequestBody);
            webcontext.RequestBody["a_FuJinMenDian"]=mendian;
            webcontext.RequestBody = JSON.stringify(webcontext.RequestBody);
            localStorage.removeItem("mendian");
        }else{
            webcontext.ResponseMessage.Success=false;
            webcontext.ResponseMessage.ErrorMessage="签到失败,附近未找到对应门店";
        }
    }
    return webcontext;
}
}